import React, { Component } from 'react';
import { Modal, Button, message, Tree } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const TreeNode = Tree.TreeNode;

class TemplateTree extends Component {
    state = {
        options: [],
        visible: false,
    }

    show = (followBoardDetailId, value) => {
        this.setState({
            value,
            visible: true,
            followBoardDetailId,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { followBoardDetailId } = this.state;
        const options = {
            method: 'post',
            url: `${API_URL.executeMgr.queryCascadeListByDetailId}`,
            data: {
                followBoardDetailId
            },
            dataType: 'json',
            doneResult: (res => {
                if (!res.error) {
                    const { value = '' } = this.state;
                    const list = value.split('/');
                    let followBoardDetailOptionId = [],
                        data = [...res.optionList];
                    if (list.length > 0) {
                        list.map(item => {
                            if (data.length > 0) {
                                data.map(innerItem => {
                                    if (innerItem.optionName == item) {
                                        followBoardDetailOptionId.push(innerItem.followBoardDetailOptionId + '');
                                        if (innerItem.childList && innerItem.childList.length > 0) {
                                            data = [...innerItem.childList];
                                        } else {
                                            data = [];
                                        }
                                    }
                                });
                            }
                        });
                    }
                    this.setState({
                        followBoardDetailOptionId,
                        dataList: res.optionList,
                    });
                }
            }),
        };
        $.sendRequest(options);
    }

    getDataList = () => {
        const { dataList = [] } = this.state;
        let data = null;
        if (dataList.length > 0) {
            data = this.loopMap(dataList);
        }
        return data;
    }

    loopMap = data => {
        return data.map(item => {
            if (item.childList && (item.childList.length > 0)) {
                return (
                    <TreeNode title={item.optionName} key={item.followBoardDetailOptionId + ''}>
                    { this.loopMap(item.childList) }
                    </TreeNode>
                )
            } else {
                return <TreeNode title={item.optionName} key={item.followBoardDetailOptionId + ''} />
            }
        })
    }

    onSelect = (selectedKeys, info) => {
        const { dataList } = this.state;
        const { isEnd = false } = this.props;
        const params = info.selectedNodes.length > 0 ? info.selectedNodes[0].props : null;
        if ((isEnd && params != null && params.children == undefined) || !isEnd) {
            let deep = info.node.props.pos.split('-') || [];
            let optionName = '', data = [...dataList];
            deep.shift();
            deep.map(item => {
                if (data.length > 0) {
                    optionName += `/${data[Number(item)].optionName}`;
                    if (data[Number(item)].childList && data[Number(item)].childList.length > 0) {
                        data = data[Number(item)].childList;
                    } else {
                        data = [];
                    }
                }
            });
            optionName = optionName && optionName.substring(1);
            this.setState({
                visible: false,
                value: optionName,
            }, () => {
                this.props.saveTemplateData({ optionId: selectedKeys[0], optionName });
            })
        } else {
            message.warning('请选择可选项已经配置的最后一级选项');
        }
    }

    render() {
        const { visible, followBoardDetailOptionId = [] } = this.state;
        let defaultId = [...followBoardDetailOptionId];
        defaultId.splice(0, defaultId.length - 1);
        return (
            visible &&
            <Modal
                title="选择可选项"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div className="modal-content">
                        <ul className="modal-list">
                            <li className="modal-item" style={{paddingBottom: 20}} key={Date.now()}>
                                <Tree
                                    defaultExpandedKeys={followBoardDetailOptionId}
                                    defaultSelectedKeys={defaultId}
                                    onSelect={this.onSelect}
                                >
                                    { this.getDataList() }
                                </Tree>
                            </li>
                        </ul>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default TemplateTree;


// WEBPACK FOOTER //
// ./src/components/execute/template/TemplateTree.js